export enum AuctionType {
    ENGLISH_AUCTION = "ENGLISH_AUCTION",
}
